import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Gift, CheckCircle2, AlertCircle } from "lucide-react";
import api, { fmtErr } from "@/lib/api";
import { Spinner } from "@/components/ui-bits";

export default function ExtenderPrueba() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [offer, setOffer] = useState(null);
  const [state, setState] = useState("loading");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!token) { setState("error"); setErr("Enlace no válido"); return; }
    api.get(`/public/trial-extension/${token}`)
      .then(({ data }) => { setOffer(data); setState(data.status === "pending" ? "ask" : data.status); })
      .catch((e) => { setErr(fmtErr(e)); setState("error"); });
  }, [token]);

  const accept = async () => {
    setBusy(true);
    try { await api.post(`/public/trial-extension/${token}/accept`); setState("accepted_now"); }
    catch (e) { setErr(fmtErr(e)); setState("error"); }
    finally { setBusy(false); }
  };

  const msg = {
    accepted: "Ya confirmaste esta extensión. Puedes entrar en la app con normalidad.",
    expired: "Esta oferta ha caducado. Escríbenos a info@smileandshine.es y te ayudamos.",
    superseded: "Este enlace ya no es válido; revisa el correo más reciente.",
  };

  return (
    <div className="min-h-screen bg-[#EEF3FA] flex items-center justify-center p-5" data-testid="page-extender-prueba">
      <div className="w-full max-w-md bg-white rounded-[32px] shadow-xl overflow-hidden text-center sns-fade-up">
        <div className="bg-[var(--coral)] px-8 py-10 text-white">
          <Gift size={44} className="mx-auto mb-3" />
          <h1 className="sns-title !text-white text-3xl">14 días más de prueba</h1>
          {offer?.tenant_name && <p className="mt-2 text-white/90">{offer.tenant_name}</p>}
        </div>
        <div className="p-8">
          {state === "loading" && <Spinner />}
          {state === "ask" && (
            <>
              <p className="text-[var(--ink)] mb-6">Confirma y tu equipo vuelve a tener acceso con todas las funciones Pro durante 14 días, sin tarjeta.</p>
              <button onClick={accept} disabled={busy} className="w-full rounded-full py-4 bg-[var(--sky-text)] text-white font-bold text-base active:scale-95 transition-transform disabled:opacity-60" data-testid="btn-accept-extension">
                {busy ? "Activando…" : "Sí, quiero probar 14 días más"}
              </button>
            </>
          )}
          {state === "accepted_now" && (
            <div data-testid="extension-accepted">
              <CheckCircle2 size={40} className="mx-auto text-emerald-600 mb-3" />
              <p className="font-bold text-[var(--ink)] text-lg">¡Listo! Tienes 14 días más.</p>
              <Link to="/login" className="mt-6 inline-block rounded-full px-8 py-3 bg-[var(--coral)] text-white font-bold" data-testid="link-go-login">Entrar en la app</Link>
            </div>
          )}
          {msg[state] && (
            <div data-testid="extension-status">
              <p className="text-[var(--ink)]">{msg[state]}</p>
              <Link to="/login" className="mt-6 inline-block text-[var(--sky-text)] font-semibold">Ir a la app</Link>
            </div>
          )}
          {state === "error" && (
            <div className="text-red-600 flex items-center justify-center gap-2" data-testid="extension-error"><AlertCircle size={18} /> {err}</div>
          )}
        </div>
      </div>
    </div>
  );
}
